import { Pipe, PipeTransform } from '@angular/core';
import { AuthService } from 'src/app/core';

@Pipe({
  name: 'rbac',
  standalone: true
})
export class RbacPipe implements PipeTransform {
  constructor(private authService: AuthService){}

  transform(value: string[], args?: any): any {
    return this.authService.rbac(value);
  }

}

